import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { Button, useTranslations } from "@jti/ui";
import styles from "./ResetSuccessful.module.scss";
const ResetSuccessful = (props) => {
    const history = useHistory();
    const { __ } = useTranslations();
    const pushToLogin = useCallback(() => {
        history.push({
            pathname: "/login",
            state: { from: "reset-password" },
        });
    }, [history]);
    return (_jsxs("div", { className: styles.container, children: [_jsxs("p", { className: styles.content, children: [_jsx(UiCheckIcon, { className: styles.checkIcon }), props.successMessage] }), _jsx(Button, { className: styles.submitButton, color: "primary", onClick: pushToLogin, "data-testid": "resetPasswordRedirectToLogin", children: __("reset_password.back_button_label") })] }));
};
export default memo(ResetSuccessful);
